const Distribuidores = () => {
    return (
        <main className = "mainSubs">
            <h1>Distribuidores Descripcion</h1>
        </main>
    )
}

export default Distribuidores
